/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateFileCountsDataSchema = z.object({
	total: z.number().default(0),
	tagged: z.object({ cv: z.number().default(0) }).default({ 'cv': 0 }),
})

export type CandidateFileCountsDataSchema = z.infer<typeof candidateFileCountsDataSchema>
